import {
    FileEntity,
    FileFireInsuranceResult,
    FileInfoEntiy,
    FilePaymentResult,
} from 'domain/entities/FileEntity';
import { FileRepository } from '../repositories/FileRepository';

export class FileUseCase implements FileUseCaseInterface {
    private fileRepo: FileRepository;

    constructor(fileRepo: FileRepository) {
        this.fileRepo = fileRepo;
    }

    async uploadFile(data: FileEntity): Promise<any> {
        return await this.fileRepo.uploadFile(data);
    }
    async getFiles(settlementId: number): Promise<FileInfoEntiy> {
        return await this.fileRepo.getFiles(settlementId);
    }
    async getFileInsurances(settlementId: number): Promise<FileFireInsuranceResult> {
        return await this.fileRepo.getFileInsurances(settlementId);
    }
    async uploadFileInsurance(data: FileEntity): Promise<any> {
        return await this.fileRepo.uploadFileInsurance(data);
    }
    async getFilePayment(params: {
        settlementId: number;
        scheduleAdjustmentDiv: number;
    }): Promise<FilePaymentResult> {
        return await this.fileRepo.getFilePayment(params);
    }

    async confirmPayment(payload: { dealId: number; scheduleAdjustmentDiv: number }): Promise<any> {
        return await this.fileRepo.confirmPayment(payload);
    }
}
export interface FileUseCaseInterface {
    uploadFile(data: FileEntity): Promise<any>;
    getFiles(settlementId: number): Promise<FileInfoEntiy>;
    getFileInsurances(settlementId: number): Promise<FileFireInsuranceResult>;
    uploadFileInsurance(data: FileEntity): Promise<any>;
    getFilePayment(params: {
        settlementId: number;
        scheduleAdjustmentDiv: number;
    }): Promise<FilePaymentResult>;
    confirmPayment(payload: { dealId: number; scheduleAdjustmentDiv: number }): Promise<any>;
}
